import React from 'react'
import { string } from 'prop-types'
import LogoCuradoria from '../../assets/imagens/logo-curadoria.svg'
import LogoIneditos from '../../assets/imagens/logo-ineditos.svg'
import Logo from '../../assets/imagens/tag-logo.svg'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS } from '../../constants'

const LogoTAG = ( { modalidade, propriedadeParaComparacao } ) => {
  const descricaoModalidade = mod => `Logotipo do clube ${mod}`
  const descricaoTAG = 'Logotipo TAG - Experiências Literárias'
  let descricao = ''
  let logo = null
  switch ( modalidade ) {
    case MODALIDADE_CURADORIA[ propriedadeParaComparacao ]:
      descricao = descricaoModalidade( modalidade )
      logo = LogoCuradoria
      break
    case MODALIDADE_INEDITOS[ propriedadeParaComparacao ]:
      descricao = descricaoModalidade( modalidade )
      logo = LogoIneditos
      break
    default:
      descricao = descricaoTAG
      logo = Logo
  }

  return (
    <img
      alt={ descricao }
      src={ logo }
    />
  )
}

LogoTAG.propTypes = {
  'modalidade': string,
  'propriedadeParaComparacao': string,
}

LogoTAG.defaultProps = {
  'modalidade': '',
  'propriedadeParaComparacao': 'slug',
}

export default LogoTAG
